<template>
  <div>
    <top-bar heading="Submission"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid pt-3" v-if="loaded">
      <div class="row">
        <div class="col-12 col-lg-6 pb-3">
          <b-card header="Submission Information" no-body class="h-100">
            <b-card-body class="h-100">
              <table class="table table-no-border">
                <tr>
                  <td class="text-right bold">Student Name</td>
                  <td>{{ submission.user.name_first+' '+submission.user.name_last }}</td>
                </tr>
                <tr>
                  <td class="text-right bold">Form Name</td>
                  <td>{{ submission.form_name }}</td>
                </tr>
                <tr>
                  <td class="text-right bold">Date of Submission</td>
                  <td>{{ submission.created_at }}</td>
                </tr>
                <tr v-if="$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer'])">
                  <td class="text-right bold">Grade Submission:</td>
                  <td>
                    <div class="row">
                      <div class="col">
                        <loading-button :loading="loading" block variant="lime" :class="{ 'btn-outline' : submission.grade_status !== 1 }" @submit="gradeSubmisson(1)" class="d-sm-down-none">SATISFACTORY</loading-button>&nbsp;
                        <loading-button :loading="loading" block variant="lime" :class="{ 'btn-outline' : submission.grade_status !== 1 }" @submit="gradeSubmisson(1)" class="d-inline d-md-none">
                          <font-awesome-icon icon="thumbs-up"></font-awesome-icon>
                        </loading-button>&nbsp;
                      </div>

                      <div class="col">
                        <loading-button :loading="loading" block variant="red" :class="{ 'btn-outline' : submission.grade_status !== 0 }" @submit="gradeSubmisson(0)" class="d-sm-down-none">NOT SATISFACTORY</loading-button>&nbsp;
                        <loading-button :loading="loading" block variant="red" :class="{ 'btn-outline' : submission.grade_status !== 0 }" @submit="gradeSubmisson(0)" class="d-inline d-md-none">
                          <font-awesome-icon icon="thumbs-down"></font-awesome-icon>
                        </loading-button>&nbsp;
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="!$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer'])">
                  <td class="text-right bold">Grade:</td>
                  <td>
                    <button v-show="submission.grade_status === 1" class="btn btn-block btn-lime">SATISFACTORY</button>
                    <button v-show="submission.grade_status === 0" class="btn btn-block btn-red">NOT SATISFACTORY</button>
                    <button v-show="submission.grade_status === 2" class="btn btn-block btn-info">NOT GRADED</button>
                  </td>
                </tr>
              </table>
            </b-card-body>
          </b-card>
        </div>
        <div class="col-12 col-lg-6 pb-3">
          <b-card header="Notes" no-body class="h-100">
            <b-card-body class="h-100 pl-3 pr-3 pt-3">
              <div class="col-12">
                <span v-html="submission.grade_notes" v-if="!$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer'])"></span>
                <vue-editor v-model="submission.grade_notes" v-if="$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer'])"></vue-editor>
              </div>
              <div class="col-12 mt-2">
                <loading-button :loading="loading" variant="primary" block @submit="saveNotes" v-if="$auth.check(['admin', 'super_admin', 'rto', 'rto_trainer'])">Save Notes</loading-button>
              </div>
            </b-card-body>
          </b-card>
        </div>
        <div class="col-12" v-if="loaded">
          <b-card header="View Submission">
            <b-card-body class="p-3">
              <form-viewer :form-id="submission.form_id" :schema="submission.form_schema" v-model="submission.form_data" on-submit="()" :read-only="true"></form-viewer>
            </b-card-body>
          </b-card>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TopBar from '../../components/TopBar'
import FormViewer from '../../components/FormViewer/FormViewer'

export default {
  name: 'SingleSubmission',
  components: { FormViewer, TopBar },
  data () {
    return {
      submission: {
        user: {},
        grade_notes: '',
        grade_status: 0,
        form_schema: { fields: [] },
        form_data: {}
      },
      loaded: false,
      loading: false
    }
  },
  methods: {
    loadSubmission (id) {
      this.loaded = false
      this.loading = true
      this.axios.get('/submissions/' + id, { params: { includes: 'user' } }).then(rsp => {
        this.submission = rsp.data.data
        this.loaded = true
        this.loading = false
      }).catch(err => this.$errorOut(err))
    },
    gradeSubmisson (status) {
      if (!this.loaded) {
        this.$snotify.error('Please wait until submission fully loaded before updating', 'Submission Error')
        return
      }
      this.loading = true
      this.submission.grade_status = parseInt(status, 10)
      this.axios.put('/submissions/' + this.id, { grade_notes: this.submission.grade_notes, grade_status: this.submission.grade_status }).then(rsp => {
        this.$swal('Success', 'Submission Graded', 'success')
        this.submission = rsp.data.data
        this.loading = false
      }).catch(err => this.$errorOut(err))
    },
    saveNotes () {
      if (!this.loaded) {
        this.$snotify.error('Please wait until submission fully loaded before updating', 'Submission Error')
        return
      }
      this.loading = true
      this.axios.put('/submissions/' + this.id, { grade_notes: this.submission.grade_notes, grade_status: this.submission.grade_status }).then(rsp => {
        this.$swal('Success', 'Submission Notes Updated', 'success')
        this.submission = rsp.data.data
        this.loading = false
      }).catch(err => this.$errorOut(err))
    }
  },
  mounted () {
    this.loadSubmission(this.id)
  },
  metaInfo: {
    title: 'Submission'
  },
  props: ['id']
}
</script>
